<template lang="pug">
.LoadingCover.hide-print
	p
		img(
			width="100"
			height="100"
			:src="image"
			:alt="message"
		)
	p(
		style="{'margin-top':0}"
	) {{ message }}
</template>

<script>
export default {
	props: {
		image: {
			type: String,
			required: true
		},
		message: {
			type: String,
			default: "Loading..."
		}
	}
}
</script>

<style lang="scss">
.LoadingCover{
	z-index: 10000;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	align-items: center;
	background: #fff;
	flex-direction: column;
	> p {
		margin-bottom: 0px;
		margin-top: 0;
	}

}
</style>
